export const CAMPAIGN_TYPES = {
  drip: {
    text: "Drip",
    deliveryTypes: {
      "Wait Days": { delay_in_days: "Wait days" },
      "Wait Minutes": { delay_in_minutes: "Wait Minutes" },
    },
  },
  event: {
    text: "Event",
    deliveryTypes: {
      Immediately: { immediate: "Immediately" },
      "Before Event": {
        minutes_before_event: "Minutes",
        days_before_event: "Days",
      },
      "After Event": {
        minutes_after_event: "Minutes",
        days_after_event: "Days",
      },
    },
  },
  reminder: {
    text: "Reminder",
    deliveryTypes: {
      Immediately: { immediate: "Immediately" },
      "Before Event": {
        minutes_before_event: "Minutes",
        days_before_event: "Days",
      },
      "After Event": {
        minutes_after_event: "Minutes",
        days_after_event: "Days",
      },
    },
  },
};
